import React, { useState, useEffect } from 'react';

const LeaveReview = () => {
    const [rating, setRating] = useState(0);
    const [heading, setHeading] = useState('');
    const [description, setDescription] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
    };

    const [loading, setLoading] = useState(false);

    // const createReview = async () => {
    //     const testingAmpEnvironment = { ...config, ...awsAppSyncConfig, };
    //     Amplify.configure(testingAmpEnvironment);
    //     const client = generateClient();

    //     const userAttributes = await fetchUserAttributes();
    //     const userID = userAttributes['custom:vendorId'];

    //     try {
    //         const createReview = await client.graphql({
    //             query: `
    //                 query MyQuery {
    //                 vendors(filter: {id: "${userID}"}) {
    //                     address
    //                     api_interest
    //                     approval_status
    //                     company_name
    //                     number_of_employees
    //                     date_founded
    //                     phone_number
    //                     service_description
    //                     serve_plan
    //                     service_specialties
    //                     vendor_bio
    //                     website
    //                     registration_email
    //                     revenue
    //                     contact_name
    //                 }   
    //                 }
    //                 `,
    //             authMode: 'userPool'

    //         });
    //         setLoading(false);

    //     } catch (error) {
    //         setLoading(false);
    //     }
    // };



    return (
        <div className="w-full flex flex-col">
            <h2>Leave a Review</h2>
            <form onSubmit={handleSubmit}>
                <div className="rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            className={star <= rating ? 'star selected' : 'star'}
                            onClick={() => setRating(star)}
                        >
                            ★
                        </button>
                    ))}
                </div>
                <div className="w-full mx-auto flex flex-col pt-4 items-center">
                    <label className="w-full text-left text-lg md:text-xl text-gray-800 mb-2">
                        Headline
                    </label>
                    <input
                        type="text"
                        id="heading"
                        value={heading}
                        onChange={(e) => setHeading(e.target.value)}
                        name="serviceSpecialties"
                        className="block py-2.5 px-4 w-full text-lg md:text-xl 2xl:text-2xl text-gray-900 border border-neutral appearance-none focus:outline-none focus:ring-0 focus:border-charmOrange"
                        placeholder="What do you want to highlight?"
                        required
                    />
                </div>

                <div className="w-full mx-auto flex flex-col pt-4 items-center">
                    <label className="w-full text-left text-lg md:text-xl text-gray-800 mb-2">
                        Description
                    </label>
                    <textarea
                        type="text"
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)} name="serviceSpecialties"
                        className="block py-2.5 px-4 w-full text-lg md:text-xl 2xl:text-2xl text-gray-900 border border-neutral appearance-none focus:outline-none focus:ring-0 focus:border-charmOrange h-40 "
                        placeholder=""
                        required
                    />
                </div>
                <div className="w-full flex justify-end">
                    <button className="text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full " type="submit">Submit Review</button>
                </div>

            </form>
        </div>
    );
};

export default LeaveReview;